import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'


export default {
  install: (app) => {
    FloatingVue.options.autoHideOnMousedown = true
    app.use(FloatingVue)
  }
}